import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, Col, Row, Form } from 'react-bootstrap';
import IconButton from 'components/common/IconButton';
import IconAlert from 'components/common/IconAlert';

import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import { nouveauRecruement } from 'helpers/yupValidationSchema';

import { Axios } from 'helpers/axios';

const Recrutement = () => {
    const [isLoading, setIsLoading] = useState(false);
    const { register, handleSubmit, formState: { errors }, reset, } = useForm({
        resolver: yupResolver(nouveauRecruement),
    });

    const [successMessage, setSuccessMessage] = useState(false);
    const postuler = async (data) => {
        try {
            setIsLoading(true);
            await Axios.post('/publicRoutes/newRecrutement',{
                ...data
            });
            reset();
            setSuccessMessage(true);
            setIsLoading(false);
        } catch (error) {
            console.error(error)
        }
    }

    return (<>
        <Card>
            <Card.Header>
                <h5 className="mb-0">Envie de nous rejoindre ?</h5>
            </Card.Header>
            <Card.Body className="bg-body-tertiary pb-0">
                <Row className="align-items-center">
                    <Col md={8}>
                        <div className={"border border-1 rounded-4 p-2 position-relative mb-2 border-warning"}>
                            <center><h5 className='text-warning'>Pour des Missions de Sécurité Civile<br/><small>(Postes de Secours, Soutien aux Populations Sinistrées, ...)</small></h5></center>
                            <hr/>
                            <p className='mb-3'>
                                Utilisez le formulaire ci-dessous pour nous laisser vos coordonnées. Un Responsable des Missions de Sécurité Civile prendra contact avec vous et vous proposera une rencontre pour vous présenter l'association et son fonctionnement.<br/>
                                A l'issu de cet entretien vous pourrez adhérer et nous rejoindre.
                            </p>
                            {successMessage ?
                                <IconAlert variant={'success'}>Merci pour votre postulation et intéret. Nous revenons vers vous au plus vite !</IconAlert>
                            :
                                <Form onSubmit={handleSubmit(postuler)} className='mb-3'>
                                    <Row>
                                        <Col md={6}>
                                            <Form.Group className="mb-2">
                                                <Form.Label>Nom</Form.Label>
                                                <Form.Control type="text" name="nomIS" id="nomIS" {...register("nomIS")} isInvalid={!!errors.nomIS}/>
                                                <small className="text-danger">{errors.nomIS?.message}</small>
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group className="mb-2">
                                                <Form.Label>Prénom</Form.Label>
                                                <Form.Control type="text" name="prenomIS" id="prenomIS" {...register("prenomIS")} isInvalid={!!errors.prenomIS}/>
                                                <small className="text-danger">{errors.prenomIS?.message}</small>
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group className="mb-2">
                                                <Form.Label>Téléphone</Form.Label>
                                                <Form.Control type="text" name="telephoneIS" id="telephoneIS" {...register("telephoneIS")} isInvalid={!!errors.telephoneIS}/>
                                                <small className="text-danger">{errors.telephoneIS?.message}</small>
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group className="mb-2">
                                                <Form.Label>Mail</Form.Label>
                                                <Form.Control type="email" name="mailIS" id="mailIS" {...register("mailIS")} isInvalid={!!errors.mailIS}/>
                                                <small className="text-danger">{errors.mailIS?.message}</small>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    
                                    <Form.Group className="mt-2">
                                        <Button className="w-100" type="submit" disabled={isLoading}>Envoyer</Button>
                                    </Form.Group>
                                </Form>
                            }
                        </div>
                    </Col>
                    <Col md={4}>
                        <div className={"border border-1 rounded-4 p-2 position-relative mb-2 border-secondary"}>
                            <center>
                                <h5 className='text-secondary'>Pour devenir formateur, ou assurer une autre fonction au sein de l'association</h5>
                                <IconButton as={Link} to='/contact' size='sm' className='mt-3 mb-3' icon='envelope' variant='outline-primary'>Contactez vous via le formulaire de contact générique</IconButton>
                            </center>
                        </div>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    </>);
};

export default Recrutement;